export default "__VITE_ASSET__D9pKT651__"